import { EventEmitter } from 'events'

export default class Viewport extends EventEmitter {

	static instance

	constructor() {

		if ( Viewport.instance ) return Viewport.instance

		super()
		Viewport.instance = this

		this.pixelRatio = window.devicePixelRatio
		this.clampedPixelRatio = Math.min( this.pixelRatio, 2.0 )
		this.dimensions = {

			x: window.innerWidth,
			y: window.innerHeight

		}

		this.resize = this.resize.bind( this )
		window.addEventListener( 'resize', this.resize )

	}

	resize( e ) {

		this.emit( 'resize', e )
		this.dimensions.x = window.innerWidth
		this.dimensions.y = window.innerHeight

	}

}
